import moment from "moment";

import template from "./pRates.html";

export function pRatesDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pRatesController,
    controllerAs: 'pRates',
    bindToController: true
  };

  return directive;
}

class pRatesController {
  constructor(Auth, Controlling, $scope, Notes, $interval, $location, $q, ConnectionQuality) {
    'ngInject';
    this.Auth = Auth;
    this.Controlling = Controlling;
    this.$scope = $scope;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$interval = $interval;
    this.$location = $location;
    this.$q = $q;

    this.thisYear = parseFloat(moment().format("YYYY"));
    this.thisMonth = moment().format("MM").length == 1 ? `0${moment().format("MM")}` : moment().format("MM");

    this.init();

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        if (!this.user.canViewRates) {
          this.$location.path('/');
        }
        this.Controlling.getSites().then(
          (success) => {
            this.sites = success.data;
            this.sites = this.sites.filter(site => site.name !== "Iterators HQ");

            var timeout = this.$interval(() => {
              this.notes = this.Notes.getNotes();
            }, 50);
            this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
          },
          (error) => {
            this.loadingRates = false;
            this.error = error;
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  selectSite() {
    if (!this.site) {
      return;
    }

    this.loadingRates = true;
    this.error = null;
    this.currentSite = angular.fromJson(this.site);
    this.newRate = {
      siteId: this.currentSite.id,
      validFromYear: this.thisYear,
      validFromMonth: this.thisMonth
    };

    this.Controlling.getRates(this.currentSite.id).then(
      (success) => {
        let rates = success.data.rates;
        this.seniorityLevels = success.data.availableSeniorityLevels;
        this.rates = [];
        this.ratesOryginal = [];
        let allRates = [];

        this.seniorityLevels.forEach( level => {
          let levelRates = rates.filter(r => r.seniorityLevel == level).sort((a,b)=> moment(b.validFrom).diff(a.validFrom)) ;
          let lastRate = levelRates.length-1;
          levelRates.forEach(l => {
            if(l.id === levelRates[0].id && lastRate != 0) {
              l.seniorityLevelToShow = l.seniorityLevel;
              l.deleteHide = false;
            }else if(lastRate == 0) {
              l.seniorityLevelToShow = l.seniorityLevel;
              l.deleteHide = true;
            }else if(l.id === levelRates[lastRate].id) {
              l.seniorityLevelToShow = "";
              l.deleteHide = true;
            } else {
              l.seniorityLevelToShow = "";
              l.deleteHide = false;
            }
          });
          allRates = allRates.concat(levelRates);
        });

        this.rates = allRates;
        this.ratesOryginal = angular.copy(allRates);
        this.loadingRates = false;
      },
      (error) => {
        this.loadingRates = false;
        this.mainError = error;
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startAddRate() {
    this.modalShown = true;
    this.newRate.validFrom = `${this.newRate.validFromYear}-${this.newRate.validFromMonth}`;
  }

  addRate() {
    this.loadingRates = true;
    let newRate = {
      rate: this.newRate.rate,
      seniorityLevel: this.newRate.seniorityLevel,
      siteId: this.newRate.siteId,
      validFrom: `${this.newRate.validFromYear}-${this.newRate.validFromMonth}`
    };
    this.Controlling.addRates(newRate).then(
      () => {
        this.loadingRates = false;
        this.modalShown = false;
        this.selectSite();
      },
      (error) => {
        this.error = error;
        this.loadingRates = false;
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  updateRates() {
    this.loadingRates = true;

    let ratesToUpdate = this.rates.filter( r => this.ratesOryginal.find( rO => rO.id === r.id).rate !== r.rate)
    .map( r => {
      return {
        id: r.id,
        rate: r.rate,
        seniorityLevel: r.seniorityLevel,
        validFrom: r.validFrom
      };
    });

    if (Array.isArray(ratesToUpdate) && ratesToUpdate.length) {
      this.Controlling.updateAllRates(ratesToUpdate).then(
        () => {
          this.loadingRates = false;
          this.selectSite();
        },
        (error) => {
          this.error = error;
          this.loadingRates = false;
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
    else{
      this.loadingRates = false;
      this.selectSite();
    }

  }

  updateRate(originalRate) {
    let rate = angular.copy(originalRate);
    delete rate.deleteHide;
    delete rate.seniorityLevelToShow;
    delete rate.siteId;
    delete rate.id;

    this.loadingRates = true;
    this.Controlling.updateRates(originalRate.id, rate).then(
      () => {
        this.loadingRates = false;
        this.selectSite();
      },
      (error) => {
        this.error = error;
        this.loadingRates = false;
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteRate(rate) {
    if(!rate.deleteHide) {
      this.loadingRates = true;
      this.Controlling.deleteRate(rate.id).then(
        () => {
          this.loadingRates = false;
          this.selectSite();
        },
        (error) => {
          this.error = error;
          this.loadingRates = false;
          this.Notes.postNote({type: "error", error: error});
        }
      );
    }
  }

}
